import { useCallback, useEffect } from 'react';

import { useApiPost } from '../../api/Api.hooks';
import { useAppContext } from '../../AppContext';

export default function useAddStudyToFavorite(userId: number, studyId: number) {
  const { data, isLoading, error, post, clearData } = useApiPost(
    `users/${userId}/favorite/study/${studyId}`
  );

  const { logError } = useAppContext();
  useEffect(
    () => void (error && logError('Add to favorite error', error)),
    [error, logError]
  );

  const addStudyToFavorite = useCallback(() => post(), [post]);
  return {
    addStudyToFavoriteData: data,
    addStudyToFavoriteIsLoading: isLoading,
    addStudyToFavoriteError: error,
    clearAddStudyToFavoriteData: clearData,
    addStudyToFavorite
  };
}
